import auth from '../utils/auth';
import axios from 'axios';

export const updateAddress = (userid, addressid, updates) => {
    return axios.request({
        url: `/customers/${userid}/addresses/${addressid}`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: updates
    });
};

export const deleteAddress = (userid, addressid) => {
    return axios.request({
        url: `/customers/${userid}/addresses/${addressid}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
};

export const addAddress = (userid, address) => {
    return axios.request({
        url: `/customers/${userid}/addresses`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: {
            ...address,
            customer_id: userid
        }
    });
};
